import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BsSearch } from "react-icons/bs";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";

export default function SearchSpotReports() {
	const [instData, setInstData] = useState([]);

	const [subject, setSubject] = useState("");
	const [catalogue, setCatalogue] = useState("");
	const [instName, setInstName] = useState("");

	var [subjectError, setSubjectError] = useState(false);
	var [nameError, setNameError] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		async function getInstructors() {
			let url = process.env.REACT_APP_BACKEND_HOST.concat("/spot/all_inst/");
			const response = await fetch(url, {
				headers: { Authorization: `Token ${sessionStorage.token}` },
			});
			const data = await response.json();
			setInstData(data);
		}
		getInstructors();
	}, []);

	function formatName(name) {
		if (name === "") {
			return "";
		}
		const nameArray = name.trim().split(/\s+/); // Split the name into an array of words
		if (nameArray.length === 1) {
			return nameArray[0];
		} else if (nameArray.length === 2) {
			return `${nameArray[1]}, ${nameArray[0]}`;
		} else {
			const lastName = nameArray[nameArray.length - 1]; // Get the last word as the last name
			const firstName = nameArray.slice(0, -1).join(" "); // Join all but the last word as the first name
			return `${lastName}, ${firstName}`; // Return the formatted name
		}
	}

	function getEMPID(name) {
		const employee = instData.find((item) => item.NAME === name);
		return employee ? employee.EMPID : "?";
	}

	function courseSearch() {
		if (subject.length > 1) {
			setSubjectError(false);
			navigate("/reporting/Search-SPOT-Results", {
				state: {
					course: subject.concat(" ", catalogue).toString(),
					inst: "?",
					empid: "?",
				},
			});
		} else {
			setSubjectError(true);
			setNameError(false);
		}
	}

	function instSearch() {
		if (instName.length > 1) {
			setNameError(false);
			navigate("/reporting/Search-SPOT-Results", {
				state: {
					course: "?",
					inst: formatName(instName).toString(),
					empid: getEMPID(instName).toString(),
				},
			});
		} else {
			setNameError(true);
			setSubjectError(false);
		}
	}

	return (
		<div style={{
			height: "100vh",
			maxHeight: `calc(100vh - calc(13rem + 8px))`,
			backgroundColor: "#F5F5F5" 
		}}>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					alignContent: "center",
				}}
			>
				<Typography variant="h2">Search SPOT Reports</Typography>
				<Typography variant="subtitle1" style={{ paddingTop: "20px" }}>
					Explore all publicly available SPOT reports administered by the University of Alberta.
					
				</Typography>
				<Typography variant="subtitle1" style={{paddingTop: "20px" }}>
					
					Easily search through by subjects and catalog combinations, as well as by an instructor's
					name.
				</Typography>

				<Box style={{ padding: "50px", 
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					alignContent: "center",}}>
					<Typography variant="h5">Specific Subject or Course</Typography>

					<form
						className="flex flex-row p-[20px]"
						onSubmit={(e) => {
							e.preventDefault();
							courseSearch();
						}}
					>
						<TextField
							sx={{
								"& .MuiOutlinedInput-root": {
									backgroundColor: "#FFF", // default (enabled)
								},
							}}
							label="Subject"
							value={subject}
							helperText="ex: ''MATH''"
							size="small"
							style={{ width: "200px", height: "40px", paddingRight: "5px" }}
							onChange={(e) => {
								setSubject(e.target.value.replace(/[^a-zA-Z]/g, "").toUpperCase());
							}}
						/>
						<TextField
							sx={{
								"& .MuiOutlinedInput-root": {
									backgroundColor: "#FFF", // default (enabled)
								},
							}}
							label="Catalogue #"
							value={catalogue}
							helperText="ex: ''100''"
							size="small"
							style={{ width: "200px", height: "40px", paddingRight: "5px" }}
							onChange={(e) => {
								setCatalogue(e.target.value.replace(/\D/g, ""));
							}}
						/>
						<Button
							variant="contained"
							type="submit"
							style={{
								backgroundColor: "#275d38",
								fontSize: "1.5rem",
								height: "40px",
								padding: "5px",
							}}
							onClick={courseSearch}
						>
							<BsSearch />
						</Button>
					</form>
					{subjectError && (
						<p style={{ color: "red", textAlign: "center", paddingTop: "10px" }}>
							Please fill out the subject field.
						</p>
					)}

					<Divider orientation="horizontal" flexItem style={{ padding: "20px" }}>
						OR
					</Divider>

					<Typography variant="h5">Specific Instructor</Typography>

					<form
						className="flex flex-row p-[20px]"
						onSubmit={(e) => {
							e.preventDefault();
							instSearch();
						}}
					>
						<Autocomplete
							sx={{
								"& .MuiOutlinedInput-root": {
									backgroundColor: "#FFF", // default (enabled)
								},
							}}
							freeSolo
							style={{ width: "400px", height: "40px", paddingRight: "5px" }}
							options={[...new Set(instData.map((option) => option.NAME))]}
							ListboxProps={{ style: { maxHeight: 200, overflowY: "scroll" } }}
							onChange={(event, value) => {
								// value is the selected option (string) when chosen from the list
								if (typeof value === "string") setInstName(value);
								else setInstName("");
							}}
							onInputChange={(event, value) => {
								// keeps state in sync while typing (freeSolo)
								setInstName(value);
							}}
							renderInput={(params) => (
								<TextField
									{...params}
									helperText="ex: ''John Doe''"
									label="Instructor Name"
									size="small"
								/>
							)}
						/>

						<Button
							variant="contained"
							type="submit"
							style={{
								backgroundColor: "#275d38",
								fontSize: "1.5rem",
								height: "40px",
								padding: "5px",
							}}
						>
							<BsSearch />
						</Button>
					</form>
					{nameError && (
						<p style={{ color: "red", textAlign: "center", paddingTop: "10px" }}>
							Please fill out the Instructor field.
						</p>
					)}
				</Box>
			</div>
		</div>
	);
}
